var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isShow)?_c('div',{staticClass:"chat_container"},[_c('a',{staticClass:"webim_button",attrs:{"href":"#","rel":"webim"}},[_c('img',{attrs:{"src":_setup.webimButton,"border":"0"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }